import { ENTITY_TYPES } from '@sales-center/common'
import { FilterChipListWrapper } from '@user/components/Filters/FilterChip'
import {
  clearedFilters,
  IOpportunity,
  OpportunityFilterSet,
  selectOpportunityFilters,
  useSaveOpportunityFilters,
} from '@user/store/opportunity'
import * as React from 'react'
import { useSelector } from 'react-redux'

export function OpportunityPageFilterChipList() {
  const saveOpportunityFilters = useSaveOpportunityFilters()
  const { filterSet } = useSelector(selectOpportunityFilters)

  return (
    <FilterChipListWrapper<IOpportunity, OpportunityFilterSet>
      applyCallback={saveOpportunityFilters}
      clearedFilters={clearedFilters}
      filterSet={filterSet}
      entityType={ENTITY_TYPES.Opportunity}
    />
  )
}
